export default __webpack_public_path__ + "static/media/Loans.d0e20813.png";